import {
  ITableColumn,
  ITableData,
  NodeUserType,
  PermissionDeptRoles,
  IWrokspaceData,
  IUser,
  ColumnType,
} from "../types/table-type";

export const getColumn = (columnId: string, tableData: ITableData): ITableColumn | null => {
  return tableData.columns.find((item) => item.id === columnId) || null;
};

type NotNull<T> = T extends null ? never : T;
export const isNotNull = <T>(arg: T): arg is NotNull<T> => arg !== null;

export type NotUndefined<T> = T extends undefined ? never : T;
export type NotUndefinedIndex<T> = { [P in keyof T]: NotUndefined<T[P]> };
export const isNotUndefined = <T>(arg: T): arg is NotUndefined<T> => arg !== undefined;

/**
 * Neither null nor undefined.
 */
export type NotNullish<T> = NotNull<NotUndefined<T>>;
export const isNotNullish = <T>(arg: T): arg is NotNullish<T> => isNotUndefined(arg) && isNotNull(arg);

export const arrayToObject = (array: any[], keyField: string) =>
  array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});

export interface IReduxUser {
  id: string;
  individualGroupId: string;
  email?: string;
  nickName: string;
  color: string;
  image?: string;
  smallImage?: string;
  phoneNumber?: string;
  hasBindWechat?: boolean | null;
  userType: NodeUserType;
  role: PermissionDeptRoles;
  inviteIds?: string[];
}

interface ICollaboratorsById {
  [userId: string]: IReduxUser | undefined;
}

export const DEPT_AUTH_OPTIONS_IDS = [PermissionDeptRoles.MEMBER, PermissionDeptRoles.ADMIN];
export const isNormalUser = (user?: IReduxUser) => {
  return !!(
    (user && (DEPT_AUTH_OPTIONS_IDS.includes(user.role) || user.role === PermissionDeptRoles.OWNER) && true)
    // TODO 暂时没有添加 userType 故跳过校验
    // [NodeUserType.NORMAL, NodeUserType.INACTIVE].includes(user.userType)
  );
};

export const isExternalUser = (user?: IReduxUser) => {
  return !!(
    user &&
    user.role === PermissionDeptRoles.GUEST &&
    [NodeUserType.NORMAL, NodeUserType.INACTIVE].includes(user.userType)
  );
};

export const getCollaboratorsBase = () => {
  // @ts-ignore
  if (!window.treelab) return { collaboratorsById: {}, collaboratorIds: [] };
  // @ts-ignore
  const usersMap = window.treelab.users as IWrokspaceData["users"];
  const users = Object.values<IUser>(usersMap.byId);
  const allIds = users.map((item) => item.id);
  const userById = arrayToObject(users, "id");

  const collaboratorsById: ICollaboratorsById = (allIds || []).reduce((byId: { [key: string]: IReduxUser }, userId) => {
    const user = userById[userId];
    if (user) {
      byId[user.id] = user;
    }
    return byId;
  }, {});

  const collaboratorIds = (allIds || []).reduce((ids: string[], userId) => {
    const user = userById[userId];
    if (user && (isNormalUser(user) || isExternalUser(user))) {
      return ids.concat([user.id]);
    }
    return ids;
  }, []);

  return { collaboratorsById, collaboratorIds };
};

export const getCollaborators = () => {
  return getCollaboratorsBase();
};

export const isDateType = (type?: ColumnType) => type === ColumnType.DATETIME || type === ColumnType.CREATED_AT;
